import { parseEditorContent } from '@components/ArtBoard/Comments/components/Comment/components/Content'
import { serializeToText } from '@octopus-do/octopus-editor'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  content: string
}

export const ThreadBody: React.FC<Props> = ({ content }) => (
  <div className={css.thread_body}>
    <span className={clsJoin(css.typography, css.clamp)}>
      {serializeToText(parseEditorContent(content))}
    </span>
  </div>
)
